import { useQuery } from '@tanstack/react-query'

import { authenticatedApi } from '../../utils/api'

async function getSalesReviewCount() {
  return authenticatedApi.get('customer/sales-review-count').json<{ size: number }>()
}

export const useSalesReviewCount = (enabled = true) => {
  return useQuery({
    queryKey: ['sales_review_count'],
    queryFn: () => getSalesReviewCount(),
    enabled,
  })
}
